import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  ButtonToolbar,
  ButtonGroup,
  ListGroup,
  ListGroupItem
} from "reactstrap";
import {loadStore, reloadPlaylist} from "../../redux/actions/index";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { StoreService } from "../../services/storeService";
import { CompanyService } from "../../services/companyService";
import { BrandService } from "../../services/brandService";
import { ChannelService } from "../../services/channelService";
import { PlaylistService } from "../../services/playlistService";
import Reproductor from "../Channel/Reproductor";
import moment from "moment";
import channels from "../Channel";

let storeService = new StoreService();
let companyService = new CompanyService();
let brandService = new BrandService();
let channelService = new ChannelService();
let playlistService = new PlaylistService();

const MINUTE = 60 * 1000;
const TEN_MINUTES = MINUTE * 10;
const HOUR = MINUTE * 60;

class Connection extends Component {
  render() {
    let lastConnection = this.props.lastConnection;
    if (lastConnection) {
      let date = new Date();
      let connectionDate = new Date(lastConnection);

      let dif = date - connectionDate;
      if (dif < TEN_MINUTES) return <span className="text-success pull-right">Conectado</span>;
      else if (dif > HOUR)
        return <span className="text-danger pull-right">Desconectado</span>;
      return <span className="text-warning pull-right">Conectado</span>;
    }
    return <span className="text-danger pull-right">-</span>;
  }
}


function getChannel(store) {
  if (store.zone) return store.zone.channelId
  else if (store.brand) return store.brand.channelId
  return null;
}
class ViewStoreConnector extends Component {
  constructor(props) {

    super(props);
    this.state = {
      files: [],
      songs: [],
      origin: '',
      originSongs: '',
      loadingFiles: true,
      storeLoaded: false,
      invalid: true,
      songLoading: false,
    }
    this.mounted = true;
    this.loadData();
    brandService.reload();
    companyService.reload();
    playlistService.reload();

  }
  componentWillUnmount() {
    this.mounted = false;
  }
  loadData() {
    let self = this;
    storeService
      .getFullStore(this.props.match.params.id)
      .then(function (data) {
        if (!data.hasOwnProperty("error")) {
          self.props.Store(data);

          channelService.reload().then(function (){
            self.setState({storeLoaded: true});
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    storeService
      .getFiles(this.props.match.params.id)
      .then(function(data){
        self.setState({files: data, loadingFiles: false});
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  getSongsFromPlaylistId(id) {
    let self = this;
    storeService
      .getSongsFromPlaylistId(id)
      .then(function(clientSongs){
        const data = clientSongs.songs;
        let result = [];
        for (let i in data) {
          if (data[i].title) {
            data[i].artist = { song: self.removeChannel(data[i].title) + (data[i].time ? ". Hora: " + data[i].time : "") };
            result.push(data[i]);
          }
        }
        self.setState({songs: result, originSongs: 'playlist', origin: clientSongs.channel, songLoading: true});
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  getSongsFromChannel(id){
    let self = this;
    storeService
      .getSongs(id)
      .then(function(clientSongs){
        const data = clientSongs.songs;
        let result = [];
        for (let i in data) {
          if (data[i].title) {
            data[i].artist = { song: self.removeChannel(data[i].title) + (data[i].time ? ". Hora: " + data[i].time : "") };
            result.push(data[i]);
          }
        }
        self.setState({songs: result, songLoading: true, originSongs: 'channel', origin: clientSongs.channel});
      })
      .catch(function (error) {
        console.log(error);
      });

  }

  removeChannel(title) {

    let newTitle = title.split("/");
    return newTitle[newTitle.length - 1].slice(0, -4);
  }

  render() {
    const { data } = this.props;

    let channel = null;

    if(this.state.storeLoaded && !this.state.songLoading){
      channel = channelService.Match(getChannel(data));  
      if(data.playlistMusicId) {
        this.getSongsFromPlaylistId(data.playlistMusicId);
      } else if(channel){ 
        this.getSongsFromChannel(channel.id);
      }
    } 
    
    else if (this.state.storeLoaded){
      const channelId = getChannel(data)
      channel = channelService.Match(channelId);
    }

    let files = this.state.files;
    let loading = this.state.loadingFiles;
    let plMusic;
    let plSpot;

    //TODO: process playlist sequence
    if(data.playlistMusicId !== null){
      plMusic = data.plMusic;
    }else if (data.zone !== null && data.zone !== undefined && data.zone.plMusic !== undefined && data.zone.plMusic !== null){
      plMusic = data.zone.plMusic
    }else if(data.brand !== null && data.brand !== undefined && data.brand.plMusic !== undefined && data.brand.plMusic !== null){
      plMusic = data.brand.plMusic
    }

    if(data.playlistSpotId !== null){
      plSpot = data.plSpot;
    }else if (data.zone !== null && data.zone !== undefined && data.zone.plSpot !== undefined && data.zone.plSpot !== null){
      plSpot = data.zone.plSpot
    }else if(data.brand !== null && data.brand !== undefined && data.brand.plSpot !== undefined && data.brand.plSpot !== null){
      plSpot = data.brand.plSpot
    }

    let songs = this.state.songs;
    let originParent = this.state.origin ? this.state.origin : {};

    const plMusicName = plMusic ? plMusic.name : ' - ';
    const plSpotName = plSpot ? plSpot.name : ' - ';

    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs="12" sm="6" lg="6">
            <Card>
              <CardHeader>
                <Row>
                  <CardTitle className="mb-0 col-sm-6">
                    Tienda: {data.name || "Cargando..."}
                  </CardTitle>
                  <Col sm="6" className="d-sm-inline-block">
                    {this.props.user.user.role === "ADMIN" && (
                      <ButtonToolbar
                        className="float-right"
                        aria-label="Toolbar with button groups"
                      >
                        <ButtonGroup className="mr-3" aria-label="First group">
                          <Link
                            to={"/stores/edit/" + this.props.match.params.id}
                            className="btn btn-outline-info btn-sm"
                          >
                            <i className="fa fa-edit" />
                          </Link>
                        </ButtonGroup>
                      </ButtonToolbar>
                    )}
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col xs="12" sm="12" lg="12">
                    <ListGroup>
                      <ListGroupItem>
                        Cliente:
                        <span className="pull-right">
                          {companyService.MatchName(data.companyId)}
                        </span>
                      </ListGroupItem>
                      <ListGroupItem>
                        Marca:
                        <span className="pull-right">
                          {brandService.MatchName(data.brandId)}
                        </span>
                      </ListGroupItem>
                      <ListGroupItem>
                        Canal:
                        <span className="pull-right">{(channel) ? channel.name : ''}</span>
                      </ListGroupItem>
                      <ListGroupItem>
                        Dispositivo:
                        <span className="pull-right">{data.computerId}</span>
                      </ListGroupItem>
                      <ListGroupItem>
                        Descripción del Canal:
                        <span className="pull-right">
                          {(channel) ? channel.description : ''}
                        </span>
                      </ListGroupItem>
                      <ListGroupItem>
                        Artistas del Canal:
                        <span className="pull-right">{(channel) ? channel.artists : ''}</span>
                      </ListGroupItem>
                      <ListGroupItem>
                        Encargado:
                        <span className="pull-right">{data.manager}</span>
                      </ListGroupItem>
                      <ListGroupItem>
                        Email:
                        <span className="pull-right">{data.email}</span>
                      </ListGroupItem>
                      <ListGroupItem>
                        Telefono:
                        <span className="pull-right">{data.telephone}</span>
                      </ListGroupItem>
                      <ListGroupItem>
                        Música:
                        <span className="pull-right">
                          {plMusicName}
                        </span>
                      </ListGroupItem>
                      <ListGroupItem>
                        Publicidad:
                        <span className="pull-right">
                          {plSpotName}
                        </span>
                      </ListGroupItem>
                    </ListGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <Row>
                  <CardTitle className="mb-0 col-sm-12">
                    Ultima Canción:
                    <span className="pull-right">{data.songName ? data.songName : "No ha tocado ninguna canción"}</span>
                  </CardTitle>
                </Row>
              </CardHeader>
              <CardHeader>
                <Row>
                  <CardTitle className="mb-0 col-sm-12">
                    Ultima Conexión:
                    <span className="pull-right">
                      {data.lastConnection
                        ? moment(data.lastConnection).format("DD/MM/YYYY HH:mm")
                        : "Nunca se ha Conectado"}
                    </span>
                  </CardTitle>
                </Row>
              </CardHeader>
              <CardHeader>
                <Row>
                  <CardTitle className="mb-0 col-sm-12">
                    Estado: <Connection lastConnection={data.lastConnection} />
                  </CardTitle>
                </Row>
              </CardHeader>
            </Card>
          </Col>
          <Col xs="12" sm="6" lg="6">
            <Card>
              <CardHeader>
                <Row>
                  <CardTitle className="mb-0 col-sm-6">
                    Playlist de música
                  </CardTitle>
                </Row>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col xs="12" sm="6" lg="6">
                    {data.id === this.props.match.params.id && (
                       // <Reproductor channel={channel && channel.serverName} />
                      <Reproductor songList={songs} channel={(channel) ? channel.id : ''} songsOrigin={(originParent) ? originParent : {}} invalid={!this.state.songLoading} />
                    )}
                  </Col>
                  <Col xs="12" sm="12" lg="12">
                    <table hover bordered striped responsive size="sm">
                      <thead>
                      </thead>
                      <tbody>
                      {(loading) && (<tr>Cargando...</tr>)}
                      {(songs.length === 0 && !loading) && (<tr>Sin datos</tr>)}
                      {songs
                        .map((e, i) => {
                          const name = e.title.split('/');
                          if(e.type === 'TYPE_PL_MUSIC'){
                            return (
                              <tr>
                                <td>{name[name.length - 1]}</td>
                              </tr>
                            );
                          }
                        })}
                      </tbody>
                    </table>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.store,
    user: state.user,
    companies: state.companies,
    channels: state.channels,
    playlists: state.playlists
  };
};

const mapDispatchToProps = dispatch => {
  return {
    Store: store => dispatch(loadStore(store)),
    reloadPlaylist: playlists => dispatch(reloadPlaylist(playlists))
  };
};

const ViewStore = connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewStoreConnector);

export default ViewStore;
